import { useState, useEffect } from "react";
import axios from "axios"
import NovoUsuario from "./components/NovoUsuario.js";
import EditarUsuario from "./components/EditarUsuario.js"
import Grid from "./components/Grid.js";
import Logs from "./components/Logs.js";

import RedButton from "../../ui/RedButton.js";
import GlobalStyle from "../../../styles/global-new.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { IoMdArrowRoundBack } from "react-icons/io";




const DivBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
    margin-top: 20px;
`;

const DivLayout = styled.div`
  width: 80vw;
  
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

  
`;

const Container = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;
  
`;

const Title = styled.nav`

  display: flex;
  justify-content: start; 
  align-items: center;
  height: 5.0rem;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  gap: 50px;
  padding-left: 10px;
  border-radius:  15px 15px  0px 0px;
  border: 1px solid #eee;
  border-bottom: none;
`;

const Title2 = styled.h2`
  display: flex;
  justify-content: space-between; 
  align-items: center;
  color: #008000;
  font-size: 28px;

  @media (max-width: 768px) {
    font-size: 20px;
    width: 90%;
  }

`;

const Div = styled.div`
  position: fixed;
  top:0;
  left:0;
  display: flex;
  flex-direction: column;
`;

const Filtro = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: end; 
  padding: 0px 0px 5px 0px;
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
`;
const ModalContent = styled.div`
  background-color: #fafafa;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 90vh; 
  overflow-y: auto; 
  border-radius: 10px;
  

`;


const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  gap: 10px;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;

function Usuarios() {

  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;

  //---------------------------------------TOKEN---------------------------------------------------//

  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');


  //---------------------------------------LISTA DE USUARIOS---------------------------------------------------//

  //recebe os dados dos usuarios
  const [usuarios, setUsuarios] = useState([]);
  const fetchUsuarios = async () => {
    try {
      const res = await axios.get(`${urlApi}portal/listar-usuarios`, { headers: { Authorization: `Bearer ${token}` } });
      setUsuarios(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de usuarios:', error);
    }
  };



  useEffect(() => {
    fetchUsuarios();
  }, [token]);


  //---------------------------------------VOLTAR A PAGINA INICIAL---------------------------------------------------//


  const handleVoltar = () => {
    window.location.href = urlFront;
  };

  //---------------------------------------VERIFICA O TOKEN---------------------------------------------------//
  //Verifica o token do usuário
  useEffect(() => {
    const getToken = async () => {
      try {
        const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
      } catch (error) {
        if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
          window.location.href = `${urlFront}login`;
        } else {
          console.error("Erro ao obter token:", error);
        }
      }
    };


    getToken();
  }, [token])


  //---------------------------------------VERIFICA SE O USUÀRIO PODE ACESSAR O MODULO---------------------------------------------------//

  useEffect(() => {
    const verificarAcessoLogado = async () => {
      try {
        const res = await axios.post(`${urlApi}portal/acessos-portal`,
          { id },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const acessos = res.data;

        // Verifica se o usuário tem acesso ao módulo 0 com tipo A
        const possuiAcessoAoModulo0 = acessos.some(
          (acesso) => acesso.COD_MODULO === 0 && acesso.TIPO_ACESSO === "A"
        );

        if (!possuiAcessoAoModulo0) {
          // Redireciona se não tiver o acesso necessário
          window.location.href = '/login';
        }

      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
        window.location.href = '/login'; // Redireciona também em caso de erro (opcional)
      }
    };

    if (token && id) {
      verificarAcessoLogado();
    }
  }, [token, id]);


  //---------------------------------------MODAL CADASTRO DE USUARIO---------------------------------------------------//

  const [isModalOpenEditarCadastrarUsuario, setIsModalOpenEditarCadastrarUsuario] = useState(false);
  const modalEditarCadastrarUsuario = () => {
    setIsModalOpenEditarCadastrarUsuario(!isModalOpenEditarCadastrarUsuario);

  };

  //---------------------------------------MODAL EDITAR DE USUARIO---------------------------------------------------//
  const [editarUsuario, setEditarUsuario] = useState('')

  const [isModalOpenEditarUsuario, setIsModalOpenEditarUsuario] = useState(false);
  const modalEditarUsuario = (item) => {
    setIsModalOpenEditarUsuario(!isModalOpenEditarUsuario);
    setEditarUsuario(item);
  };

  //---------------------------------------MODAL LOG DOS USUARIOS---------------------------------------------------//
  const [isModalOpenLogUsuario, setIsModalOpenLogUsuario] = useState(false);
  const modalLogsUsuario = () => {
    setIsModalOpenLogUsuario(!isModalOpenLogUsuario);

  };

  //---------------------------------------PESQUISAR OS ACESSOS DOS USUARIOS---------------------------------------------------//

  //recebe os dados dos acessos
  const [acessos, setAcessos] = useState([]);


  //Limpa os states quando fecho o modal:
  useEffect(() => {
    if (!isModalOpenEditarUsuario) {
      setEditarUsuario('');
      setAcessos([]);
    }
  }, [isModalOpenEditarUsuario]);

  const buscarAcessosParaEdicao = async () => {
    if (!editarUsuario || !editarUsuario.COD_FUNCIONARIO) return;

    try {
      const res = await axios.post(`${urlApi}portal/acessos-portal`, {
        id: editarUsuario.COD_FUNCIONARIO
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setAcessos(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de acessos:', error);
    }
  };

  useEffect(() => {


    if (editarUsuario?.COD_FUNCIONARIO) {
      buscarAcessosParaEdicao();
    }
  }, [editarUsuario]);



  //---------------------------------------LISTA OS MODULOS CADASTRADOS---------------------------------------------------//

  //recebe os dados dos acessos
  const [modulos, setModulos] = useState([]);
  useEffect(() => {
    const fetchModulos = async () => {
      if (!editarUsuario || !editarUsuario.COD_FUNCIONARIO) return;
      try {
        const res = await axios.get(`${urlApi}portal/modulos`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setModulos(res.data);
      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
      }
    };

    fetchModulos();
  }, [editarUsuario]);


  //---------------------------------------LISTA DE LOGS de ACESSO---------------------------------------------------//

  //recebe os dados dos acessos
  const [logsAcesso, setLogsAcesso] = useState([]);
  useEffect(() => {
    const fetchLogsAcesso = async () => {

      try {
        const res = await axios.get(`${urlApi}portal/logs-acesso/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLogsAcesso(res.data);
      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
      }
    };

    fetchLogsAcesso();
  }, [token, id]);

  //---------------------------------------LISTA DE LOGS de ALTERACAO---------------------------------------------------//

  //recebe os dados dos acessos
  const [logsAlteracao, setLogsAlteracao] = useState([]);
  useEffect(() => {
    const fetchLogsAlteracao = async () => {

      try {
        const res = await axios.get(`${urlApi}portal/logs-alteracao/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setLogsAlteracao(res.data);
      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
      }
    };

    fetchLogsAlteracao();
  }, [token, id]);

  //--------------------------------------------------------------------//
  return (
    <div style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden', width: '100vw' }}>
      <DivBody>

        {isModalOpenEditarCadastrarUsuario && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <RedButton onClick={() => {
                  modalEditarCadastrarUsuario();
                }}>
                  Fechar
                </RedButton>
              </ButtonContainer>
              <NovoUsuario urlApi={urlApi} fetchUsuarios={fetchUsuarios} />
            </ModalContent>
          </ModalContainer>
        )}

        {isModalOpenEditarUsuario && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <RedButton onClick={() => {
                  modalEditarUsuario();
                }}>
                  Fechar
                </RedButton>
              </ButtonContainer>
              <EditarUsuario urlApi={urlApi} editarUsuario={editarUsuario} acessos={acessos} modulos={modulos} fetchUsuarios={fetchUsuarios} />
            </ModalContent>
          </ModalContainer>
        )}

        {isModalOpenLogUsuario && (
          <ModalContainer>
            <ModalContent>
              <ButtonContainer>
                <RedButton onClick={() => {
                  modalLogsUsuario();
                }}>
                  Fechar
                </RedButton>
              </ButtonContainer>
              <Logs logsAcesso={logsAcesso} logsAlteracao={logsAlteracao} />
            </ModalContent>
          </ModalContainer>
        )}
        <div>
          <DivLayout>
            <Title>

              <Title2>
                <ActionButton className="toggle-btn" onClick={handleVoltar}>
                  <IoMdArrowRoundBack className="gap" /> Voltar
                </ActionButton>

              </Title2>

              <Title2>
                <h2>Cadastro de Usuários</h2>
              </Title2>

            </Title>
          </DivLayout>

          <Container>
            <Filtro>
              <Grid modalEditarUsuario={modalEditarUsuario} urlApi={urlApi} usuarios={usuarios} fetchUsuarios={fetchUsuarios} modalEditarCadastrarUsuario={modalEditarCadastrarUsuario} modalLogsUsuario={modalLogsUsuario} />
            </Filtro>

          </Container>
          <Div>
            <ToastContainer autoClose={2500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />
            <GlobalStyle />
          </Div>
        </div>
      </DivBody>
    </div>
  );
}

export default Usuarios;
